import dayjs from 'dayjs';

const STORAGE_KEY = 'app_ui_filters';
const DATE_RANGE_FIELDS = ['dateRange', 'appliedDateRange'];

export const FILTER_NAMESPACES = {
  BROADCAST_CAMPAIGNS: 'broadcast_campaigns',
  SCHEDULE_CAMPAIGNS: 'schedule_campaigns',
  RCS_CAMPAIGNS: 'rcs_campaigns',
  WHATSAPP_TEMPLATES: 'whatsapp_templates',
  SMS_TEMPLATES: 'sms_templates',
  RCS_TEMPLATES: 'rcs_templates',
  TEMPLATE_ANALYTICS: 'template_analytics',
  BOTBRIDGE_ANALYTICS: 'botbridge_analytics',
  AUDIT_TRAIL: 'audit_trail',
  MARKETING_LOGS: 'marketing_logs',
  WHATSAPP_MESSAGE_LOGS: 'whatsapp_message_logs',
  RCS_BROADCAST_LOGS: 'rcs_broadcast_logs',
  RCS_CHAT_LOGS: 'rcs_chat_logs',
  VOICE_LOGS: 'voice_logs',
};

export const DEFAULT_CAMPAIGN_FILTERS = {
  campaignType: '',
  audience: '',
  status: '',
  templateId: '',
  templateName: '',
  createdBy: '',
  dateRange: [null, null],
  appliedDateRange: [null, null],
};

function readAll() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

function writeAll(all) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch {
    // ignore quota errors
  }
}

function serializeFilters(filters) {
  const result = { ...filters };
  for (const field of DATE_RANGE_FIELDS) {
    if (Array.isArray(result[field])) {
      result[field] = result[field].map((d) => (d ? d.toISOString() : null));
    }
  }
  return result;
}

function deserializeFilters(filters, defaults) {
  const result = { ...defaults, ...filters };
  for (const field of DATE_RANGE_FIELDS) {
    if (Array.isArray(result[field])) {
      result[field] = result[field].map((d) => (d ? dayjs(d) : null));
    }
  }
  return result;
}

export function loadFilters(namespace, defaults = {}) {
  try {
    const all = readAll();
    if (!all[namespace]) return { ...defaults };
    return deserializeFilters(all[namespace], defaults);
  } catch {
    return { ...defaults };
  }
}

export function saveFilters(namespace, filters) {
  try {
    const all = readAll();
    all[namespace] = serializeFilters(filters);
    writeAll(all);
  } catch {
    // ignore
  }
}

export function clearFilters(namespace) {
  try {
    const all = readAll();
    delete all[namespace];
    writeAll(all);
  } catch {
    // ignore
  }
}

export function loadValue(namespace) {
  try {
    return readAll()[namespace];
  } catch {
    return undefined;
  }
}

export function saveValue(namespace, value) {
  try {
    const all = readAll();
    all[namespace] = value;
    writeAll(all);
  } catch {
    // ignore
  }
}
